<template>
  <div class="bgcinza">
    <div v-if="$vuetify.breakpoint.mdAndUp" fluid :class="[$route.path !== '/' ? 'white' : '']">
      <v-container class="header">
        <div class="right">
          <ul class>
            <v-btn
              class="my-2"
              v-for="(s, i) in social"
              :key="i"
              :href="s.link"
              :title="s.link"
              icon
              fab
              x-small
            >
              <v-icon class="dourado">{{ s.icon }}</v-icon>
            </v-btn>
          </ul>
        </div>

        <div class="center">
          <router-link class="white--text h-100" to="/">
            <img class="logo mx-10" src="/img/logo.png" contain height="100%" />
          </router-link>
        </div>
      </v-container>

      <div class="bgazul center">
        <nav class>
          <v-btn
            :class="[ current === route.path ? 'active' : '', 'white--text']"
            v-for="(route, i) in menu"
            :key="i"
            :to="route.path"
            text
          >{{route.name}}</v-btn>
        </nav>
      </div>
    </div>

    <template v-else>
      <v-app-bar fixed color="primary" app>
        <router-link class="h-100 white--text" to="/">
          <img class="logo" src="/img/icon.png" contain height="100%" />
        </router-link>

        <v-spacer></v-spacer>

        <v-app-bar-nav-icon color="white" @click="drawer = !drawer"></v-app-bar-nav-icon>
      </v-app-bar>

      <v-navigation-drawer v-model="drawer" fixed temporary>
        <v-subheader>MENU</v-subheader>
        <v-list-item-group v-model="current">
          <v-list dense>
            <v-list-item v-for="(route, i) in menu" :key="i" :to="route.path" link>
              <v-list-item-icon>
                <v-icon>{{ route.icon }}</v-icon>
              </v-list-item-icon>

              <v-list-item-content>
                <v-list-item-title>{{ route.name }}</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-list>
        </v-list-item-group>
      </v-navigation-drawer>
    </template>
  </div>
</template>

<script>
export default {
  data() {
    return {
      drawer: false,
      menu: [
        { path: "/", name: "HOME", icon: "fas fa-home" },
        { path: "/conheca", name: "CONHEÇA", icon: "fas fa-info-circle" },
        { path: "/diretoria", name: "DIRETORIA", icon: "fas fa-sitemap" },
        { path: "/noticias", name: "NOTÍCIAS", icon: "fas fa-newspaper" },
        {
          path: "/projeto",
          name: "PROJETO MT 140/422",
          icon: "fas fa-bookmark"
        },
        {
          path: "/transparencia",
          name: "TRANSPARÊNCIA",
          icon: "fas fa-download"
        },
        { path: "/fotos", name: "FOTOS", icon: "fas fa-camera" },
        { path: "/cotacoes", name: "COTAÇÃO", icon: "fas fa-calculator" },
        { path: "/contato", name: "FALE CONOSCO", icon: "fas fa-envelope" }
      ],
      current: this.$route.path
    };
  },
  computed: {
    social() {
      return this.$store.state.holder.social;
    }
  }
};
</script>

<style scoped>
.header div {
  width: 100%;
  display: inline-block;
}
.logo {
  height: 100%;
  object-fit: contain;
  max-width: 500px;
  width: 100%;
}
.center {
  text-align: center;
}
.right {
  text-align: right;
}
.bgazul {
  background: rgb(2, 0, 36);
  background: linear-gradient(
    180deg,
    rgba(2, 0, 36, 1) 0%,
    rgba(29, 123, 207, 1) 0%,
    rgba(25, 102, 169, 1) 100%
  );
  padding: 10px 0;
  border-top: 4px solid #485155;
  border-bottom: 4px solid #e1b768;
}
.bgcinza {
  background: #fafafa;
}
.dourado {
  color: #e1b768 !important;
}
</style>